import { render, staticRenderFns } from "./AssetBin.vue?vue&type=template&id=9d68774c&"
import script from "./AssetBin.vue?vue&type=script&lang=js&"
export * from "./AssetBin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports